import { withWorkSummaryDetailView } from '../../components/WorkSummaryDetailView'

const WorkSummaryDetailView = withWorkSummaryDetailView(
  'Completed Assignments',
  (workSummary) => workSummary.completedJobAssignments,
)

export default WorkSummaryDetailView
